import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { filterTheData } from '../actions';
import { FetchCaseBrandModel } from '../models/case_study';
import FilterItem from './shared/FilterItem'

const FilterBar = () => {
  const filterList = useSelector((state: FetchCaseBrandModel) => state);
  const dispatch = useDispatch();
  
  const clearFilter = () => {
    dispatch(filterTheData())
    var subtitles = document.querySelectorAll('.subtitle');;
    subtitles.forEach((item: any)=> item.getAttribute("style") !== null ? item.removeAttribute("style") : null)
  }
  
  if(filterList.type_filter_list.length === 0)
    return (<div>Loading...</div>)

  return (
    <div className="filter-bar">
      <p className="btn-clear" 
      style={{opacity: `${filterList.is_filter_list.length !== 0 ? 1 : 0}`, transition: "0.5s"}} 
      onClick={()=> clearFilter()}>clear</p>
      {
        filterList.type_filter_list.map((item, i)=>{
          return <FilterItem filterItem={item} key={i}/>
        })
      }
    </div>
  )
}

export default FilterBar;
